import { render, staticRenderFns } from "./SelecaoUnicaTpl.vue?vue&type=template&id=6c0016b2&"
import script from "./SelecaoUnicaTpl.vue?vue&type=script&lang=js&"
export * from "./SelecaoUnicaTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports